(function () {
  var config = window.shippingLinerAutoAddConfig || {};
  var configuredVariantId = Number(config.variantId);
  var configuredProductId = Number(config.productId);
  var configuredProductHandle = typeof config.productHandle === 'string' ? config.productHandle : '';
  var debug = false;
  var resolvedVariantId = Number.isFinite(configuredVariantId) && configuredVariantId > 0 ? configuredVariantId : null;
  var hasFallbackSource =
    (configuredProductHandle && configuredProductHandle.length > 0) ||
    (Number.isFinite(configuredProductId) && configuredProductId > 0);

  if (!config.enabled || (!resolvedVariantId && !hasFallbackSource)) {
    return;
  }

  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isRunning = false;
  var rerunRequested = false;
  var runningPromise = null;
  var publishTimer = null;
  var linerAddInFlight = false;
  var lastKnownLinerInCart = null;
  var pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
  var publishFn = typeof publish === 'function' ? publish : window.publish;
  var subscribeFn = typeof subscribe === 'function' ? subscribe : window.subscribe;
  var resolveVariantPromise = null;

  window.__withCartLock = window.__withCartLock || function (fn) {
    window.__cartOpsQueue = window.__cartOpsQueue || Promise.resolve();
    var run = function () { return Promise.resolve().then(fn); };
    var next = window.__cartOpsQueue.then(run, run);
    window.__cartOpsQueue = next.catch(function () {});
    return next;
  };

  function log() {
    if (!debug || !window.console || !window.console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[shipping-liner-auto-add]');
    window.console.log.apply(window.console, args);
  }

  function warn() {
    if (!window.console || !window.console.warn) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[shipping-liner-auto-add]');
    window.console.warn.apply(window.console, args);
  }

  function toPath(urlLike) {
    try {
      return new URL(urlLike, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function route(path) {
    return cartRoot + path.replace(/^\//, '');
  }

  function isCartAddPath(pathname) {
    return /\/cart\/add\.js$/.test(pathname);
  }

  function hasInternalLinerHeader(init) {
    if (!init || !init.headers) return false;

    if (typeof Headers !== 'undefined' && init.headers instanceof Headers) {
      return init.headers.get('X-Liner-Auto-Add') === '1';
    }

    if (Array.isArray(init.headers)) {
      return init.headers.some(function (entry) {
        return Array.isArray(entry) && String(entry[0]).toLowerCase() === 'x-liner-auto-add' && String(entry[1]) === '1';
      });
    }

    return String(init.headers['X-Liner-Auto-Add'] || init.headers['x-liner-auto-add'] || '') === '1';
  }

  function itemVariantId(item) {
    return Number(item && (item.id || item.variant_id));
  }

  function isLinerItem(item) {
    var itemVid = itemVariantId(item);
    return !!resolvedVariantId && itemVid === resolvedVariantId;
  }

  function getShippingProtectionVariantId() {
    var el = document.querySelector('#cart-shipping-protection-checkbox');
    var vid = el ? Number(el.dataset.variantId) : null;
    return Number.isFinite(vid) && vid > 0 ? vid : null;
  }

  function isAuxiliaryItem(item) {
    if (isLinerItem(item)) return true;
    var protectionVariantId = getShippingProtectionVariantId();
    return !!protectionVariantId && itemVariantId(item) === protectionVariantId;
  }

  function findLinerLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return (
      cart.items.find(function (item) {
        return isLinerItem(item);
      }) || null
    );
  }

  // function hasNonLinerItems(cart) {
  //   if (!cart || !Array.isArray(cart.items)) return false;
  //   return cart.items.some(function (item) {
  //     return !isLinerItem(item);
  //   });
  // }

  function hasNonLinerItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (item) {
      return !isAuxiliaryItem(item);
    });
  }

  function fetchCart() {
    return fetch(route('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart fetch failed with status ' + response.status);
      }
      return response.json();
    });
  }

  function addLiner(addVariantId) {
    linerAddInFlight = true;
    return fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Liner-Auto-Add': '1',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: addVariantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer,cart-live-region-text',
        sections_url: window.location.pathname,
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Failed to add shipping liner (' + response.status + ')');
      return response.json();
    }).finally(function () {
      linerAddInFlight = false;
    });
  }

  function extractVariantIdFromProductData(productData) {
    if (!productData) return null;

    var variants = Array.isArray(productData.variants) ? productData.variants : [];
    if (!variants.length) return null;

    var preferred =
      variants.find(function (variant) {
        return variant && variant.available;
      }) || variants[0];

    if (!preferred || !preferred.id) return null;
    return Number(preferred.id) || null;
  }

  function resolveVariantFromHandle() {
    if (!configuredProductHandle) return Promise.resolve(null);

    return fetch(route('products/' + configuredProductHandle + '.js'), {
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(extractVariantIdFromProductData)
      .catch(function () {
        return null;
      });
  }

  function resolveVariantFromProductId() {
    if (!Number.isFinite(configuredProductId) || configuredProductId <= 0) {
      return Promise.resolve(null);
    }

    return fetch(route('products.json?limit=250'), {
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (data) {
        var products = data && Array.isArray(data.products) ? data.products : [];
        var matched = products.find(function (product) {
          return Number(product && product.id) === configuredProductId;
        });
        return extractVariantIdFromProductData(matched);
      })
      .catch(function () {
        return null;
      });
  }

  function resolveVariantIdIfNeeded() {
    if (resolvedVariantId) {
      return Promise.resolve(resolvedVariantId);
    }

    if (resolveVariantPromise) {
      return resolveVariantPromise;
    }

    resolveVariantPromise = resolveVariantFromHandle()
      .then(function (variantIdFromHandle) {
        if (variantIdFromHandle) return variantIdFromHandle;
        return resolveVariantFromProductId();
      })
      .then(function (resolved) {
        resolvedVariantId = Number(resolved) || null;
        return resolvedVariantId;
      })
      .finally(function () {
        resolveVariantPromise = null; 
      });

    return resolveVariantPromise;
  }

  // function removeLinerByKey(lineKey) {
  //   return fetch(route('cart/change.js'), {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     credentials: 'same-origin',
  //     body: JSON.stringify({
  //       id: lineKey,
  //       quantity: 0,
  //     }),
  //   }).then(function (response) {
  //     if (!response.ok) throw new Error('Failed to remove shipping liner (' + response.status + ')');
  //     return response.json();
  //   });
  // }

  function removeLinerByKey(lineKey) {
  return fetch(route('cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      id: lineKey,
      quantity: 0,
      sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer,cart-live-region-text',
      sections_url: window.location.pathname,
    }),
  }).then(function (response) {
    if (!response.ok) throw new Error('Failed to remove shipping liner (' + response.status + ')');
    return response.json();
  });
}

  // function setLinerQuantityByKey(lineKey, quantity) {
  //   return fetch(route('cart/change.js'), {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     credentials: 'same-origin',
  //     body: JSON.stringify({
  //       id: lineKey,
  //       quantity: quantity,
  //     }),
  //   }).then(function (response) {
  //     if (!response.ok) throw new Error('Failed to set shipping liner quantity (' + response.status + ')');
  //     return response.json();
  //   });
  // }

  function setLinerQuantityByKey(lineKey, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer,cart-live-region-text',
        sections_url: window.location.pathname,
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Failed to set shipping liner quantity (' + response.status + ')');
      return response.json();
    });
  }

  function notifyThemeCartUpdate() {
    if (!(publishFn && pubSubEvents && pubSubEvents.cartUpdate)) {
      return;
    }

    clearTimeout(publishTimer);
    publishTimer = setTimeout(function () {
      publishFn(pubSubEvents.cartUpdate, {
        source: 'shipping-liner-auto-add',
      });
    }, 50);
  }

  function queueEnsure() {
    rerunRequested = true;
    if (!isRunning) ensureShippingLiner();
  }

  function queueEnsureWithDelays(delays) {
    (delays || []).forEach(function (delay) {
      setTimeout(queueEnsure, delay);
    });
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return '';
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.querySelector(selector);
    return source ? source.innerHTML : '';
  }

  function toggleCartDrawerEmptyState(parsedState) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    if (!parsedState || typeof parsedState.item_count !== 'number') return;
    cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  function patchSectionsFromResponse(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
      cartDrawer.renderContents(parsedState);

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
        cartDrawer.renderContents(parsedState);
        toggleCartDrawerEmptyState(parsedState);   // ADD THIS LINE
        return;
      }

      return;
    }

    var updates = [
      { sectionKey: 'cart-drawer', targetSelector: '#CartDrawer', sourceSelector: '#CartDrawer' },
      { sectionKey: 'cart-icon-bubble', targetSelector: '#cart-icon-bubble', sourceSelector: '.shopify-section' },
      { sectionKey: 'main-cart-items', targetSelector: '#main-cart-items .js-contents', sourceSelector: '.js-contents' },
      { sectionKey: 'main-cart-footer', targetSelector: '#main-cart-footer .js-contents', sourceSelector: '.js-contents' },
      { sectionKey: 'cart-live-region-text', targetSelector: '#cart-live-region-text', sourceSelector: '.shopify-section' },
    ];

    updates.forEach(function (entry) {
      var html = parsedState.sections[entry.sectionKey];
      if (!html) return;

      var target = document.querySelector(entry.targetSelector);
      if (!target) return;

      var inner = getSectionInnerHTML(html, entry.sourceSelector);
      if (!inner) return;
      target.innerHTML = inner;
    });
    toggleCartDrawerEmptyState(parsedState);
  }

  function maybeFastAddLinerAfterCartAdd() {
    if (linerAddInFlight) return;
    if (lastKnownLinerInCart !== false) return;
    resolveVariantIdIfNeeded()
      .then(function (targetVariantId) {
        if (!targetVariantId) return null;
        return addLiner(targetVariantId).then(function (parsedState) {
          patchSectionsFromResponse(parsedState);
          notifyThemeCartUpdate();
        });
      })
      .catch(function (error) {
        warn(error);
      })
      .finally(function () {
        queueEnsureWithDelays([120, 260, 480]);
      });
  }

  function ensureShippingLiner() {
    if (isRunning) {
      rerunRequested = true;
      return runningPromise || Promise.resolve();
    }

    isRunning = true;
    rerunRequested = false;

    runningPromise = window.__withCartLock(function () {
      return fetchCart();
    })
      .then(function (cart) {
        var linerLine = findLinerLine(cart);
        var cartHasNonLinerItems = hasNonLinerItems(cart);
        lastKnownLinerInCart = !!linerLine;
        log('Cart check', {
          itemCount: cart.item_count,
          hasNonLinerItems: cartHasNonLinerItems,
          linerFound: !!linerLine,
          resolvedVariantId: resolvedVariantId,
        });

        if (cartHasNonLinerItems && !linerLine) {
          if (linerAddInFlight) {
            return null;
          }
          return resolveVariantIdIfNeeded().then(function (targetVariantId) {
            if (!targetVariantId) {
              throw new Error('Unable to resolve shipping liner variant ID');
            }
            return addLiner(targetVariantId).then(function (parsedState) {
              patchSectionsFromResponse(parsedState);
              notifyThemeCartUpdate();
            });
          });
        }

        if (cartHasNonLinerItems && linerLine && Number(linerLine.quantity) !== 1) {
          // return setLinerQuantityByKey(linerLine.key, 1).then(notifyThemeCartUpdate);
          return setLinerQuantityByKey(linerLine.key, 1).then(function (parsedState) {
            patchSectionsFromResponse(parsedState);
            notifyThemeCartUpdate();
          });
        }

        if (!cartHasNonLinerItems && linerLine) {
          // return removeLinerByKey(linerLine.key).then(notifyThemeCartUpdate);

          return removeLinerByKey(linerLine.key).then(function (parsedState) {
            patchSectionsFromResponse(parsedState);
            notifyThemeCartUpdate();
          });
        }

        return null;
      })
      .catch(function (error) {
        warn(error);
      })
      .finally(function () {
        isRunning = false;
        runningPromise = null;
        if (rerunRequested) {
          rerunRequested = false;
          return ensureShippingLiner();
        }
      });

    return runningPromise;
  }

  function installFetchListener() {
    if (!window.fetch || window.__shippingLinerFetchPatched) return;
    window.__shippingLinerFetchPatched = true;

    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url;
      var pathname = requestUrl ? toPath(requestUrl) : '';
      var isCartAdd = isCartAddPath(pathname);
      var isInternalLinerRequest = hasInternalLinerHeader(init);

      return originalFetch(input, init).then(function (response) {
        if (isCartAdd && response && response.ok) {
          if (!isInternalLinerRequest) {
            maybeFastAddLinerAfterCartAdd();
          }
          queueEnsure();
          queueEnsureWithDelays([70, 160, 320, 600]);
        }
        return response;
      });
    };
  }

  function installXHRListener() {
    if (!window.XMLHttpRequest || window.__shippingLinerXHRPatched) return;
    window.__shippingLinerXHRPatched = true;

    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__shippingLinerCartAddRequest = isCartAddPath(toPath(url));
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.__shippingLinerCartAddRequest) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            if (!this.__shippingLinerInternalRequest) {
              maybeFastAddLinerAfterCartAdd();
            }
            queueEnsure();
            queueEnsureWithDelays([70, 160, 320, 600]);
          }
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function installFormSubmitListener() {
    if (window.__shippingLinerFormListenerInstalled) return;
    window.__shippingLinerFormListenerInstalled = true;

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.action) return;
        var pathname = toPath(form.action);
        if (!/\/cart\/add$/.test(pathname) && !/\/cart\/add\.js$/.test(pathname)) return;

        queueEnsureWithDelays([90, 200, 380, 650]);
      },
      true
    );
  }

  if (subscribeFn && pubSubEvents && pubSubEvents.cartUpdate) {
    subscribeFn(pubSubEvents.cartUpdate, function () {
      queueEnsure();
    });
  }

  installFetchListener();
  installXHRListener();
  installFormSubmitListener();
  log('Initialized', {
    configuredVariantId: configuredVariantId,
    configuredProductId: configuredProductId,
    configuredProductHandle: configuredProductHandle,
    enabled: !!config.enabled,
  });

  window.__shippingLinerAutoAdd = {
    runNow: ensureShippingLiner,
    queue: queueEnsure,
    getState: function () {
      return {
        configuredVariantId: configuredVariantId,
        configuredProductId: configuredProductId,
        configuredProductHandle: configuredProductHandle,
        resolvedVariantId: resolvedVariantId,
        isRunning: isRunning,
        rerunRequested: rerunRequested,
      };
    },
  };

  function bootstrap() {
    resolveVariantIdIfNeeded()
      .catch(function () {
        return null;
      })
      .finally(queueEnsure);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
